import { render, staticRenderFns } from "./NewMainPage.vue?vue&type=template&id=55b95ebe&scoped=true&"
import script from "./NewMainPage.vue?vue&type=script&lang=js&"
export * from "./NewMainPage.vue?vue&type=script&lang=js&"
import style0 from "./NewMainPage.vue?vue&type=style&index=0&id=55b95ebe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b95ebe",
  null
  
)

export default component.exports